<template>
  <div class="events">
    <Management
      :title="$t('scheduler.event.name-plural')"
      :fields="fields"
      :data="items"
      :can-create="false"
      :loading="loading"
      sort="modification"
      inspect-route="/classes/"
      :create-route="null"
    ></Management>
  </div>
</template>

<script>
import Management from "@/components/utilities/Management";

export default {
  components: {
    Management
  },
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    loading: true,
    items: []
  }),
  computed: {
    fields() {
      return [
        {
          name: "title",
          text: this.$t("scheduler.event.fields.title"),
          sortable: true
        },
        {
          name: "start",
          text: this.$t("scheduler.event.fields.start"),
          sortable: true
        },
        {
          name: "end",
          text: this.$t("scheduler.event.fields.end"),
          sortable: true
        },
        {
          name: "abstract",
          text: this.$t("scheduler.event.fields.abstract"),
          sortable: true
        }
      ];
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.items = JSON.parse(JSON.stringify(this.events));
      this.loading = false;
    });
  }
};
</script>
